import { createNamespacedLocalStorageFunctions } from '../local-storage';

export default createNamespacedLocalStorageFunctions('classifier');
